// extracted by mini-css-extract-plugin
export var root = "B_tq";
export var wrapper = "B_tr";
export var image = "B_ts d_s d_v d_S";
export var crop = "B_tt";
export var round = "B_tv";
export var fixedHeight = "B_tw";